/**
 * Common celestial object identifiers for the Horizons system
 */
export var CELESTIAL_OBJECTS;
(function (CELESTIAL_OBJECTS) {
    // Planets
    CELESTIAL_OBJECTS["Mercury"] = "199";
    CELESTIAL_OBJECTS["Venus"] = "299";
    CELESTIAL_OBJECTS["Earth"] = "399";
    CELESTIAL_OBJECTS["Mars"] = "499";
    CELESTIAL_OBJECTS["Jupiter"] = "599";
    CELESTIAL_OBJECTS["Saturn"] = "699";
    CELESTIAL_OBJECTS["Uranus"] = "799";
    CELESTIAL_OBJECTS["Neptune"] = "899";
    // Dwarf Planets
    CELESTIAL_OBJECTS["Pluto"] = "999";
    CELESTIAL_OBJECTS["Ceres"] = "1";
    CELESTIAL_OBJECTS["Eris"] = "136199";
    CELESTIAL_OBJECTS["Makemake"] = "136472";
    CELESTIAL_OBJECTS["Haumea"] = "136108";
    // Moons
    CELESTIAL_OBJECTS["Moon"] = "301";
    CELESTIAL_OBJECTS["Phobos"] = "401";
    CELESTIAL_OBJECTS["Deimos"] = "402";
    CELESTIAL_OBJECTS["Io"] = "501";
    CELESTIAL_OBJECTS["Europa"] = "502";
    CELESTIAL_OBJECTS["Ganymede"] = "503";
    CELESTIAL_OBJECTS["Callisto"] = "504";
    CELESTIAL_OBJECTS["Titan"] = "606";
    CELESTIAL_OBJECTS["Enceladus"] = "602";
    // Sun and barycenters
    CELESTIAL_OBJECTS["Sun"] = "10";
    CELESTIAL_OBJECTS["SolarSystemBarycenter"] = "0";
    CELESTIAL_OBJECTS["EarthMoonBarycenter"] = "3";
})(CELESTIAL_OBJECTS || (CELESTIAL_OBJECTS = {}));
/**
 * Observer center codes
 */
export var OBSERVER_CENTERS;
(function (OBSERVER_CENTERS) {
    /** Geocentric (Earth center) */
    OBSERVER_CENTERS["Geocentric"] = "500@399";
    /** Solar System Barycenter */
    OBSERVER_CENTERS["SolarSystemBarycenter"] = "500@0";
    /** Heliocentric (Sun center) */
    OBSERVER_CENTERS["Heliocentric"] = "500@10";
    /** Topocentric (requires custom coordinates) */
    OBSERVER_CENTERS["Topocentric"] = "500@399a";
})(OBSERVER_CENTERS || (OBSERVER_CENTERS = {}));
